import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { getSettingEnableLoggedOutProductTileRedesign } from "@faire/retailer/settings/getSettingEnableLoggedOutProductTileRedesign";

export const useIsLoggedOutProductTileRedesign = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  return !isLoggedInRetailer && getSettingEnableLoggedOutProductTileRedesign();
};
